<template>
  <div class="HistoryPage">
    <backgroundTop title="遵义医科大学附属医院" />
    <historyFrom />
    <CopyRight />
  </div>
</template>
<script>
import backgroundTop from '../components/backgroundTop'
import historyFrom from '../components/historyFrom'
import CopyRight from '../components/CopyRight'

export default {
  name: 'History',
  components: {
    backgroundTop,
    historyFrom,
    CopyRight
  }
}
</script>
<style lang="scss" scoped></style>
